import { useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import LoginPage from './pages/LoginPage'
import ChatPage from './pages/ChatPage'
import DashboardPage from './pages/DashboardPage'
import TodosPage from './pages/TodosPage'
import CanonPage from './pages/CanonPage'
import AgentDashboardPage from './pages/AgentDashboardPage'
import AdminPage from './pages/AdminPage'
import IdeaWorkspacePage from './pages/IdeaWorkspacePage'
import NewIdeaPage from './pages/NewIdeaPage'
import ValidationPage from './pages/ValidationPage'
import CanonEditorPage from './pages/CanonEditorPage'
import AnalyticsPage from './pages/AnalyticsPage'
import FeaturedIdeaPage from './pages/FeaturedIdeaPage'
import SettingsPage from './pages/SettingsPage'
import ProfilePage from './pages/ProfilePage'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'
import KeyboardShortcutsPanel from './components/KeyboardShortcutsPanel'
import useKeyboardShortcuts from './hooks/useKeyboardShortcuts'

function AppRoutes() {
  const [showShortcuts, setShowShortcuts] = useState(false)

  useKeyboardShortcuts({
    onShowShortcuts: () => setShowShortcuts((prev) => !prev),
  })

  return (
    <>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes with Layout */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          {/* Dashboard is the landing page (idea hub) */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/todos" element={<TodosPage />} />
          <Route path="/canon" element={<CanonPage />} />
          <Route path="/canon/:idea" element={<CanonPage />} />
          <Route path="/canon/:idea/:doc" element={<CanonPage />} />

          {/* Idea workspace routes */}
          <Route path="/ideas/:id" element={<IdeaWorkspacePage />} />
          <Route path="/ideas/:id/edit" element={<CanonEditorPage />} />
          <Route path="/ideas/:id/tests" element={<ValidationPage />} />
          <Route path="/ideas/new" element={<NewIdeaPage />} />

          {/* Admin routes */}
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/agent" element={<AgentDashboardPage />} />
          <Route path="/admin/analytics" element={<AnalyticsPage />} />

          {/* Settings & Profile */}
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/:userId" element={<ProfilePage />} />

          {/* Featured ideas */}
          <Route path="/featured/:id" element={<FeaturedIdeaPage />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <KeyboardShortcutsPanel
        isOpen={showShortcuts}
        onClose={() => setShowShortcuts(false)}
      />
    </>
  )
}

export default function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}
